module.exports = __webpack_public_path__ + "static/media/purchase-seat.07bcaf30.png";